import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import { URL } from "../config";

const RequesttypeModal = ({ onClose, requesttype }) => {
  const [requestTypeName, setRequestTypeName] = useState(requesttype?.RequestTypeName || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRequestTypeName(requesttype?.RequestTypeName || "");
  }, [requesttype]);

  const handleSubmit = async () => {
    if (!requestTypeName.trim()) {
      toast.error("Please enter request type name!");
      return;
    }

    setLoading(true);
    try {
      if (requesttype) {
        await axios.patch(`${URL}/requesttypes/${requesttype.RequestTypeId}`, {
          RequestTypeName: requestTypeName,
        });
        toast.success("Request type updated successfully!");
      } else {
        await axios.post(`${URL}/requesttypes`, { RequestTypeName: requestTypeName });
        toast.success("Request type added successfully!");
      }
      setTimeout(() => onClose?.(), 500);
    } catch (err) {
      console.error(err);
      toast.error("Operation failed!");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": { borderColor: "#c4c4c4", borderWidth: "1.5px" },
    },
    "& .MuiInputLabel-root": { fontSize: "18px", color: "#184459ff", fontWeight: 600 },
    "& .MuiInputLabel-root.Mui-focused": { color: "#184459ff" },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        p: 2,
      }}
    >
      <Box sx={{ width: { xs: "90%", sm: 400 }, bgcolor: "#fff", borderRadius: 2, p: 3 }}>
        <Typography variant="h6" sx={{ textAlign: "center", color: "#184459ff", mb: 2 }}>
          {requesttype ? "Edit Request Type" : "Add Request Type"}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="SurveyAim Name"
            size="small"
            value={requestTypeName}
            onChange={(e) => setRequestTypeName(e.target.value)}
            sx={fieldStyle}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{ backgroundColor: "#184459ff", "&:hover": { backgroundColor: "#184459ff" } }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : requesttype ? "Update" : "Save"}
            </Button>

            <Button
              variant="contained"
              sx={{ backgroundColor: "#757575ff", "&:hover": { backgroundColor: "#757575ff" } }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default RequesttypeModal;
